/**
 * Determine what route to redirect a user to when they login.
 *
 * Various users are redirected to various routes based on their user group and access level.
 */

const routeMaps = {
  SHIPPER_USER: "/shipper/dashboard",
  SHIPPER_MANAGER: "/shipper/dashboard",
  PORT_USER: "/port/dashboard",
  PORT_MANAGER: "/port/dashboard",
  NIMASA_USER: "/nimasa-agent/dashboard",
  NIMASA_MANAGER: "/nimasa-manager/dashboard",
  ADMIN_USER: "/admin/dashboard",
  NIMASA_ADMIN: "/admin/dashboard"
};

/**
 * Determine what route to redirect a user to when they login.
 *
 * @param {*} roles
 */
const getRouteFromUserRole = roles => {
  const defaultRole = roles[0];

  if (defaultRole) {
    const url = routeMaps[defaultRole];

    if (url) {
      return url;
    }
  }

  return "/userRole/has/no/url";
};

export default getRouteFromUserRole;
